import { render, staticRenderFns } from "./BatchesPanelSlot.vue?vue&type=template&id=946f4bb0&scoped=true"
import script from "./BatchesPanelSlot.vue?vue&type=script&lang=js"
export * from "./BatchesPanelSlot.vue?vue&type=script&lang=js"
import style0 from "./BatchesPanelSlot.vue?vue&type=style&index=0&id=946f4bb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946f4bb0",
  null
  
)

export default component.exports